import ServiceDistributionService from '../Services/ServiceDistributionService';
export const saveUpdateServiceDistribution = (serviceDistribution) => async (dispatch) => {
    try {
        const res = await ServiceDistributionService.saveUpdateServiceDistribution(serviceDistribution);
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

